export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "FIM Sustainability Strategy 2021-2025",
    "shortTitle": "",
    "description": "",
    "width": 1183,
    "height": 837,
    "currentLanguage": "EN",
    "languages": [],
    "basePath": "/2021-2025",
    "companyLogo": "logo.png",
    "publishURL": "https://sustainability.fim-moto.com/2021-2025/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": false,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": false,
      "downloadPath": '',
      "printEnabled": false,
      "zoomEnabled": true,
      "contentsEnabled": true,
      "languagesEnabled": false,
      "editionsEnabled": false,
      "mobileSwitch": false,
      "guideEnabled": false,
      "galleryCaptions": {},
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
      <img class="halfScale 1-logo" style="left:-1px;top:587px;" src="/2021-2025/static/_content/1-logo.png">
      <img class="halfScale 1-text" style="left: 270px;top: 586px;" src="/2021-2025/static/_content/1-sub.png">
      <img class="halfScale 1-text" style="left: 269px;top: 640px;" src="/2021-2025/static/_content/1-title.png">
      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.staggerFromTo(cOf("1-text"), 0.6, {x: 60, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)
          .fromTo(cOf("1-logo"), 0.6, {x: -250}, {x:0}, "-=0.3")
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "SUSTAINABILITY STRATEGY 2021-2025 The Future in Pole Position"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
        <div class="addContentLink" style="top: 394px;left: 80px;width: 85px;height: 27px;" onclick="Publish.goToPage(3)"></div>
        <div class="addContentLink" style="top: 471px;left: 80px;width: 129px;height: 27px;" onclick="Publish.goToPage(5)"></div>
        <div class="addContentLink" style="top: 546px;left: 80px;width: 129px;height: 54px;" onclick="Publish.goToPage(6)"></div>
        <div class="addContentLink" style="top: 648px;left: 80px;width: 123px;height: 26px;" onclick="Publish.goToPage(8)"></div>
        <div class="addContentLink" style="top: 394px;left: 293px;width: 123px;height: 77px;" onclick="Publish.goToPage(9)"></div>
        <div class="addContentLink" style="top: 521px;left: 293px;width: 107px;height: 53px;" onclick="Publish.goToPage(11)"></div>
        <div class="addContentLink" style="top: 622px;left: 293px;width: 146px;height: 53px;" onclick="Publish.goToPage(12)"></div>
        <div class="addContentLink" style="top: 724px;left: 293px;width: 64px;height: 28px;" onclick="Publish.goToPage(13)"></div>
        <div class="addContentLink" style="top: 393px;left: 508px;width: 161px;height: 28px;" onclick="Publish.goToPage(14)"></div>
        <div class="addContentLink" style="top: 469px;left: 508px;width: 70px;height: 28px;" onclick="Publish.goToPage(15)"></div>
        <div class="addContentLink" style="top: 545px;left: 508px;width: 96px;height: 28px;" onclick="Publish.goToPage(16)"></div>
        <div class="addContentLink" style="top: 621px;left: 508px;width: 104px;height: 28px;" onclick="Publish.goToPage(17)"></div>
        <div class="addContentLink" style="top: 697px;left: 508px;width: 162px;height: 55px;" onclick="Publish.goToPage(18)"></div>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Contents 3 Foreword 5 FIM at a glance 6 Three decades of impact 8 The ride so far  9 Our 2021-2025 Sustainability Circuit 11 Our spheres of influence 12 Aligning with the Global Goals 13 People  14 Sustainable Events 15 Climate 16 Awareness 17 Governance  RallyZone - Edoardo Bauer 18 Sustainable Development Goals FIM SUSTAINABILITY STRATEGY 2 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "“Making sustainability a priority futureproofs our organisation and our sport” Environmental protection and conservation has been a priority for the FIM for three decades, and I’m proud to lead an organisation that has been so committed and consistent on this issue for such a long period of time. The FIM became the first International Sports Federation to adopt an Environmental Code in 1994. And over the subsequent years we expanded our efforts to establish an FIM Sustainability Policy and International Sustainability Commission (CID). But it is clear that we have to do more; climate change and environmental degradation threaten every aspect of our existence. We believe that the FIM and wider motorcycling family can play a significant role in combating this crisis through innovation in low-carbon alternatives and the awareness we can generate through our world-class events and championships.  Our commitment to driving gender equality, quality education and good health through our sport remains stronger than ever, and this four-year sustainability roadmap (or circuit as we like to call it) attempts to further a number of the UN Sustainable Development Goals as we approach 2030. At the FIM, we believe that making sustainability a priority not only gives us a licence to operate – it futureproofs our organisation and sport. It makes us more robust, more relevant, and more in-tune with our important stakeholders. This strategy is the next important ride on that journey.  Jorge Viegas, FIM President  FIM SUSTAINABILITY STRATEGY 3 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "I believe in a sport beyond entertainment. I believe that our events can leave a legacy and influence behaviour change. I believe in sport as a facilitator of sustainable development.  I invite our committed, talented and creative FIM family to work towards each of the objectives outlined in this strategy. Please be assured that we are here to support you every step of the way.  Over the past 30 years, the FIM has been able to realise that ambition through concrete environmental protection regulations and a holistic approach to sustainability.  We want to ride into the future safe in the knowledge that future generations will enjoy the freedom and excitement of the two-wheel experience on a planet that is healthy, safe and equitable.  During that time, our sustainability journey has evolved and over the next four years we will attempt to generate an even greater positive impact through this revamped strategy. We believe this is a genuine, sincere, and transparent approach adapted to current needs. This document reflects the essential areas in which we have based our work over the last few years, and where we will expand our focus, including climate, certification, and advancing global objectives such as the UN Sustainable Development Goals.  Guillermo Hernández  “We believe this is a genuine, sincere, and transparent approach”  Ride green!  Kattia Juárez Dubón, Director of the FIM International Sustainability Commission (CID)  FIM SUSTAINABILITY STRATEGY 4 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "14  6  115  FAIRNESS, INCLUSION, UNITY AND TRANSPARENCY  NATIONAL FEDERATIONS  COMMISSIONS PROFESSIONALISM AND EXPERTISE  CONTINENTAL UNIONS  100+  WORLD CHAMPIONSHIPS, WORLD CUPS AND TROPHIES  250+  1904  HEALTH, SAFETY AND ENVIRONMENT  Values  FIM ESTABLISHED EXCELLENCE  FIM EVENTS PER YEAR  1500+  EVENTS PER YEAR INCLUDING NATIONAL AND INTERNATIONAL EVENTS  IOC  RECOGNISED  FIM at a glance  PASSION AND COMMITMENT  FIM SUSTAINABILITY STRATEGY  5"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
      <a href="https://www.fim-moto.com/fileadmin/library/Environmental_Code_2020_EN_For_website.pdf" target="_blank">
        <div class="addContentLink" style="top: 494px;left: 46px;width: 117px;height: 17px;"></div>
      </a>
      <a href="https://www.fim-moto.com/en/fim/commissions/international-sustainability" target="_blank">
        <div class="addContentLink" style="top: 528px;left: 46px;width: 227px;height: 17px;"></div>
      </a>
      <a href="https://www.fim-moto.com/fileadmin/user_upload/Campagnes/Ride-Green/Book_light_final_FIM_Ride_Green_061117.pdf" target="_blank">
        <div class="addContentLink" style="top: 663px;left: 342px;width: 212px;height: 17px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "Three decades of impact The publication of this 2021-2025 Sustainability Strategy marks another significant milestone on the FIM’s never-ending journey to become more socially and environmentally responsible And while a strategy is often the starting point for many organisations, we see this as the continuation and evolution of a sustainability programme we have been developing for almost 30 years. In 1994, the FIM became the first International Sports Federation to publish an Environmental Code – a landmark document that we have updated yearly since. The International Sustainability Commission (CID),  formerly known as the International Environment Commission, was established shortly afterwards and tasked with overseeing all matters related to sustainability. During the interim years, we have continually tried to identify areas in which our organisation and sport can make a genuinely positive social and environmental impact. The FIM was one of the first International Sports Federations to agree a Memorandum of Understanding with UN Environment (UNEP) in 2006, and over the last decade we have put a lot of effort into moving the needle with a number of key initiatives. One of our most significant moves was to give our Ride Green sustainability programme a face through the recruitment of our first FIM Environmental Ambassadors – Laia Sanz, Takahisa Fujinami, and Marc Márquez – with a handful of other high-profile riders joining since, including Randy de Puniet, Alex Salvini, Greg Hancock, Pablo Quintanilla and Jeremy Seewer.  One of our most significant moves was to give our Ride Green sustainability programme a face through the recruitment of our first FIM Environmental Ambassadors – Laia Sanz, Takahisa Fujinami, and Marc Márquez – with a handful of other high-profile riders joining since, including Randy de Puniet, Alex Salvini, Greg Hancock, Pablo Quintanilla and Jeremy Seewer. FIM SUSTAINABILITY STRATEGY 1 6"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
      <a href="https://www.fim-moto.com/fileadmin/user_upload/Campagnes/Ride-Green/20151126_Jerez_Declaration_Signed_scan.pdf" target="_blank">
        <div class="addContentLink" style="top: 663px;left: 348px;width: 102px;height: 17px;"></div>
      </a>
      `,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "We made the environment a key objective in our wider organisational FIM Strategic Plan to take a more integrated approach and, in the field of gender equality, established a Women’s Commission (CFM). It is the FIM’s firm belief that education is one of the fundamental pillars of sustainable development, so we created three positions that receive regular training. FIM Environmental Stewards are nominated by National Federations to monitor the events and keep an environmental checklist. Five experienced FIM Environmental Instructors deliver education and training  for the Environmental Stewards and other stakeholders. And Environmental Delegates (members of the CID) audit events for their environmental compliance. The Jerez Declaration, which confirmed the FIM’s commitment to environmental sustainability and the advancement of women, emphasised the level of importance of both issues as we seek to secure the future health and success of our organisation and sport.  In 2012, we published the FIM Sustainability Policy (updated in 2020) to establish a culture of sustainability in motorcycle sport worldwide. This 2021-2025 Sustainability Strategy is an extension of that work; our pledge to keep sustainability at the forefront of all our operations, decisions and conversations, backed by an unwavering belief that our sport can have a significant positive impact on sustainable development through clear guidance, commitment and passion.  2012  The FIM sustainability policy is published, to establish a culture of sustainability in motorcycle sport worldwide  FIM SUSTAINABILITY STRATEGY 1 7"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "2006  The ride so far First FIM Environmental Code published  1998  International Environment Commission – now International Sustainability Commission (CID) – established  First FIM Environmental Award established  2012  2015  First FIM Environmental Ambassadors recruited  Jerez Declaration  2012  1996  signed  FIM Sustainability Policy published  Environmental Steward role created  2010  Environment designated as key objective in FIM Strategic Plan  First FIM MotoE championship launched in  2019  2017  First FIM Trial-E Cup (electric bike series) organised  Pep Segalés  1994  1997  Memorandum of Understanding signed with UNEP  FIM SUSTAINABILITY STRATEGY  8"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "People  Empowering, inspiring and educating FIM volunteers, riders, participants, delegates, organisers, staff, fans and those associated with us so that sustainability is a key priority when they’re practicing, organising, enjoying or making important decisions.  Sustainable events Making sure our world-class events, and those responsible for operating them, adopt best practice environmental and social standards, and facilitate sustainable development.  Climate  Our climate strategy is oriented towards an emission reduction plan promoting sustainable mobility and designing a CO2 neutralisation strategy.  Our 2021-2025 Sustainability Circuit The FIM has identified and mapped out six strategic priorities on a circuit to emphasise our sport’s close affinity with sustainable development and to represent our circular, never-ending approach to sustainability. We believe these are the areas that align most closely to the FIM’s activities, and in which we can have the most positive impact.  Sustainable Development Goals Accelerating the United Nations’ 17 Global Goals through our activities and deepening the relationships between motorcycling and sustainable development.  Governance  Ensuring that sustainability is baked into the FIM’s organisational culture (FIM Family), including through our relationships with partners and suppliers.  Awareness  Showcasing our sustainability work to a larger audience and encouraging people and organisations within the motorcycle family to adopt sustainable behaviours. FIM SUSTAINABILITY STRATEGY 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "“We want to ride into the future safe in the knowledge that future generations will enjoy the freedom and excitement of the two-wheel experience on a planet that is healthy, safe and equitable.” Kattia Juárez Dubón, Director of the FIM International Sustainability Commission (CID)  FIM SUSTAINABILITY STRATEGY 10 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Dario Agrati  FIM as an organisation  Our spheres of influence Within our six strategic sustainability priorities are several key objectives and actions we will take to make sure they are achieved. As an International Sports Federation and recognised member of the Olympic Movement, we have aligned our strategy with the International Olympic Committee’s model, which identifies its impact as an organisation, as the owner of the Olympic Games, and as the leader of the Olympic Movement. Our spheres of influence also stretch beyond what we do organisationally, so we have set sustainability objectives related to our events and our influence over the wider motorcycle family.  FIM to become a more sustainable organisation and adopt sustainability principles within day-to-day operations  13  OBJECTIVES  FIM as a championship owner  FIM as leader of the motorcycle family  FIM to leverage its world-class events and championships to implement and showcase social and environmental best practice  FIM to guide and encourage the wider motorcycle family to become more systematic about sustainability and to use their skills and platforms to accelerate positive change  7  7  OBJECTIVES  OBJECTIVES  FIM SUSTAINABILITY STRATEGY 11 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "The United Nations Sustainable Development Goals (SDGs) – or Global Goals, as they are commonly known – were adopted by all UN member states in 2015, as well as several organisations since.  G2F Media  Aligning with the Global Goals  The 17 SDGs are a “universal call-to-action” outlining our biggest challenges – including poverty, hunger, climate change, inequality, and conflict – and setting a deadline of 2030 to address them. Naturally, the FIM is committed to accelerating the SDGs and that is reflected in this strategy. With the support of our Environmental Stewards and International Sustainability Commission (CID), we’ve identified the Goals where we believe we can make the biggest positive impact.  FIM SUSTAINABILITY STRATEGY 12 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "People To make genuine progress with our sustainability objectives, we need our people to be committed, educated and empowered. Our Environmental Instructors, Environmental Stewards and Environmental Delegates are crucial to our success, but our ambition is to have individuals throughout the FIM and motorcycle family driving positive social and environmental impact.  OBJECTIVES DRIVE a culture of sustainability within the FIM PROMOTE environmental education and training for staff, events hosts and the wider motorcycling family PROVIDE high class education to our Environmental Stewards and Environmental Delegates to control our events and educate at national level MOBILISE our young practitioners to accelerate sustainable development through motorcycling PROMOTE gender equality and Inclusion in motorcycling  ACTIONS DEVELOP seminars related to the organisation of sustainable events and for the volunteer FIM Environmental Stewards PROVIDE more environmental education for FIM staff, organisers and the wider motorcycle family through audiovisual tools CONTINUE to train Environmental Instructors in the fields of sustainability, public speaking and teaching CREATE more content and online courses through the FIM Academy platform DELIVER educational materials to young grassroots practitioners CID TO WORK alongside Women’s Commission (CFM) on new targets and objectives FIM SUSTAINABILITY STRATEGY 13 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Right Hub  Sustainable Events World-class events are the beating heart of the FIM. And whether it is Circuit Racing, Motocross, Enduro, Trial, Speedway or Rallies, those events must aspire to demonstrate the highest social and environmental standards. We have made a lot of progress already, but over the next four years we want to make sustainability a systematic part of every FIM event planning and hosting process.  OBJECTIVES IMPLEMENT Ride Green Certification at permanent and semi-permanent FIM event facilities ACHIEVE ISO 20121 sustainable events standard for Trial discipline INCREASE presence of CID at race events EFFECTIVELY CONTROL FIM events via the new Online Sustainable Event Control Checklist ALIGN more FIM events with relevant standards, policies and legislation CONTINUE to promote KiSS sustainability programme at the different motorcycle disciplines  ACTIONS UPDATE and increase training for FIM Environmental Stewards UPDATE FIM Environmental Code and apply to both event participants and organisers DEVELOP Ride Green Certification programme for permanent event facilities CREATE Sustainable Event Guide for main FIM disciplines ADHERE to ISO 20121 sustainable event management system for Trial events CONTINUE to rollout FIM Checklist to monitor the application of environmental regulations and rules at FIM events  FIM SUSTAINABILITY STRATEGY 14 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Climate Climate change is the defining issue of our time and poses a huge threat to our sport as well as humanity more generally. The FIM is committed to reducing its own CO2 impact as well as using its influence to accelerate the defosilisation of the motorcycle sector.  OBJECTIVES DEVELOP the FIM Net Zero Strategy MAKE climate action a key organisational priority PROMOTE the reduction of the CO2 impact of our organisation and events PROMOTE electric-powered and other alternative energy championships  ACTIONS ESTABLISH a permanent climate action working group DRAFT FIM Net Zero Strategy CONTINUE to research and promote electric and alternative energy innovation in our championships EDUCATE the motorcycle family about the need for climate action CONTINUE to promote our CO2 Calculator for partners and events FIM SUSTAINABILITY STRATEGY 15 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Awareness Although the FIM has had an Environmental Policy since 1994, we have not yet used all our channels to consistently tell our stakeholders about the significant sustainability work we have carried out in the subsequent three decades. We intend to use this period of our sustainability journey to fully utilise our high-profile platform, and increase the awareness of our work in this area.  OBJECTIVES  ACTIONS  MULTIPLY the impact of our Ride Green Ambassador programme  HELP Ride Green Ambassadors leverage their popularity to bring environmental message to more fans  CONTINUE to promote the FIM Environmental Trophy  DEVELOP a media plan for sustainability awareness  LAUNCH an annual FIM Sustainability Week USE all of our channels to increase stakeholder awareness of FIM sustainability programmes  POPULATE Ride Green webpage with more engaging content LAUNCH annual Ride Green Ambassador programme campaign PUBLISH more articles and social media posts related to sustainability with support from FIM Community Manager PARTICIPATE in forums and conferences to share the FIM sustainability journey ORGANISE webinars or forums for FIM and motorcycle family PLAN and host the annual FIM Sustainability Week FIM SUSTAINABILITY STRATEGY 16 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Governance ‘Walking the talk’ and ‘having your house in order’ are two phrases often associated with sustainability. In order to be successful with our social and environmental objectives, we have to ensure the FIM – and associated bodies – are doing the right things as an organisation.  OBJECTIVES  ACTIONS  MAINTAIN and promote a permanent environmental programme  ESTABLISH an Electric Station at FIM HQ to promote electric car and bike adoption  PLACE sustainability criteria into the FIM’s partnership and supplier agreements  PROVIDE sustainability education for Continental Union and National Federation senior leaders  ENCOURAGE Continental Unions and National Federations to become systematic about sustainability HOST more sustainable administrative and internal events PROMOTE electrification and alternative energy  MAINTAIN a CID* Bureau to provide strategic and technical sustainability leadership INCLUDE representatives from Continental Unions and National Federations within CID Bureau ORGANISE internal working groups within the CID in the fields of education and training, UN Sustainable Development Goals, regulations, awareness, and sustainable event management * Commission Internationale de la Durabilité (International Sustainability Commission)  FIM SUSTAINABILITY STRATEGY 17 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Sustainable Development Goals In 2015, the United Nations set out a roadmap towards a more sustainable and equitable world in the form of 17 Sustainable Development Goals (or SDGs). We believe the FIM and wider motorcycle family have the ability to contribute to the attainment of several of these objectives, and will embed them within our sustainability work for years to come.  OBJECTIVES  ACTIONS  ESTABLISH tangible relationship between FIM activity and the Sustainable Development Goals  ORGANISE workshops and seminars for staff and the motorcycle family around the Sustainable Development Goals  EMPHASISE the relationship between motorcycling (and the motorcycle industry) and the Sustainable Development Goals  ESTABLISH partnerships and alliances with complementary organisations to advance the Sustainable Development Goals  BECOME a key actor in the acceleration of several Sustainable Development Goals  EDUCATE the FIM Environmental Instructors, Environmental Stewards and Environmental Delegates on the wider Sustainable Development Goals FIM SUSTAINABILITY STRATEGY 18 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "“I am very proud of being a Ride Green Ambassador for the FIM as it has given me the chance to help protect nature, which is absolutely crucial in today’s world. One of the things I like most about being an Ambassador is meeting with young people and sharing a positive message with them. We can win titles and prizes, and be remembered for that. But having a positive impact on someone and changing their attitude about looking after our planet is priceless. That is why we continue with our sport.” FIM Ambassador Marc Márquez 8 times FIM World Champion  FIM SUSTAINABILITY STRATEGY 19 1"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }
  
      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }
      
      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) { 
          return e.className = 'addContentLink'
        })
      }
  
      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
      }
  
      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }
  
      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }


// WEBPACK FOOTER //
// ./src/document.js